/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerLookupUserByEmailQueryResponse, TrimbleDiagnosticsControllerLookupUserByEmailQueryParams, TrimbleDiagnosticsControllerLookupUserByEmail400, TrimbleDiagnosticsControllerLookupUserByEmail401, TrimbleDiagnosticsControllerLookupUserByEmail403, TrimbleDiagnosticsControllerLookupUserByEmail404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerLookupUserByEmail";

function getTrimbleDiagnosticsControllerLookupUserByEmailUrl() {
  const res = { method: 'GET', url: `/api/v1/trimble-user-email-diagnostics` as const }  
  return res
}

/**
 * @summary Resolve a Trimble IAM user TID from an email
 * {@link /api/v1/trimble-user-email-diagnostics}
 */
export async function trimbleDiagnosticsControllerLookupUserByEmail(params: TrimbleDiagnosticsControllerLookupUserByEmailQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleDiagnosticsControllerLookupUserByEmailQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupUserByEmail400 | TrimbleDiagnosticsControllerLookupUserByEmail401 | TrimbleDiagnosticsControllerLookupUserByEmail403 | TrimbleDiagnosticsControllerLookupUserByEmail404>, unknown>({ method : "GET", url : getTrimbleDiagnosticsControllerLookupUserByEmailUrl().url.toString(), params, ... requestConfig })  
  return res.data
}